module.exports = __webpack_public_path__ + "static/img/mobile.de95f42.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/download/mobile.webp
// module id = gqdW
// module chunks = 3